class GenericNetworkError extends Error {
    constructor(cause?: Error) {
        super("Error de red desconocido", {
            cause,
        });
    }
}

export { GenericNetworkError };
